import { PsaTypes } from '../config/types';

export const PsaTicketFieldNames = {
  [PsaTypes.Autotask]: {
    company: 'company',
    contact: 'contact',
  },
  [PsaTypes.SuperOps]: {
    company: 'clientName',
    contact: 'userName',
  },
  [PsaTypes.Halo]: {
    company: 'clientName',
    contact: 'userName',
  },
  [PsaTypes.Connectwise]: {
    company: 'companyName',
    contact: 'contactName',
  },
};
